import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

export const userRegister = async (values) => {
  const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" ,    
             lang: getLangFromLocalStorage(),
},
    body: JSON.stringify(values),
  });
  if (!response.ok) {
    const errorData = await response.json();
    const error = new Error("Registration failed");
    error.response = errorData;
    throw error;
  }
  return response;
};